import { render, staticRenderFns } from "./IdentityProof.vue?vue&type=template&id=bc9a6cb8&scoped=true&"
import script from "./IdentityProof.vue?vue&type=script&lang=js&"
export * from "./IdentityProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9a6cb8",
  null
  
)

export default component.exports